const routes = {
    name: 'Budget',
    icon: 'mdi-cash-multiple',
    path: '/reports/timhortons/controls/',
    children: [
      {
        path: '/reports/timhortons/controls/fiscalBudget',
        name: 'Fiscal Budget',
        component: () => import('./FiscalBudget.vue'),
        permissions: ['thBudget'],
      },
    ]
  };
  
  export default routes;